<!--
 * @Author: Scarlett Xiao
 * @Date: 2021-12-20 14:36:20
 * @LastEditors: dong
 * @LastEditTime: 2026-02-26 10:13:29
-->

<template>
  <div id="app" :class="'container'">
    <div class="container-wrap">
      <!-- 头部 -->
      <h5 class="container-title">
        <!-- 可视化时，使用查询参数 -->
        <HeaderQuery v-if="showHeaderQuery" @changedDate="changedDate"
          :defaultYear="(routeName === 'yc' || routeName === 'ym') ? presidentYear : middleYear"></HeaderQuery>
        <span class="obj-title">{{ title }}</span>
        <!-- 中层管理日（月）桌面切换 -->
        <div class="uyu-setting-box">
          <RouteTarget v-if="
            showHeaderQuery &&
            $route.name &&
            ($route.name.indexOf('day-') > -1 ||
              $route.name.indexOf('month-') > -1)
          " class="view-change" :pathName="
  $route.name.indexOf('day-') > -1
    ? 'month-yc'
    : 'day-yc'
" :target="'_self'">
            <span class="view-change-title" v-if="menuFlag.middleDay && menuFlag.middleMonth">
              切换{{
                $route.name && $route.name.indexOf("day-") > -1 ? "月" : "日"
              }}管理桌面
            </span>
          </RouteTarget>
          <RouteTarget class="view-change" :pathName="oldRouter" :target="'_self'" v-if="
            $route.name !== 'ym' &&
            $route.name !== 'yc' &&
            $route.name !== 'day-ym' &&
            $route.name !== 'day-yc' &&
            $route.name !== 'month-ym' &&
            $route.name !== 'month-yc'
          ">
            <span class="view-change-title">返回图表展示</span>
          </RouteTarget>
          <!-- 系统设置菜单 -->
          <div class="language-body">
            <div class="body-text">
              <div class="topbar-title">{{ userName | capitalize }}</div>
              <div class="topbar-icon">
                <span class="el-icon-arrow-down"></span>
                <span class="el-icon-arrow-up"></span>
              </div>
            </div>
            <div class="body-button uppop-toward">
              <div class="title">欢迎 {{ userName | capitalize }}</div>
              <hr />
              <div class="body-button-inner">
                <button class="exit" type="button" @click="logout()">退出</button>
              </div>
            </div>
          </div>
        </div>
      </h5>
      <!-- 内容 -->
      <router-view v-if="isShow" :dateType="dateType" :date="date" />
    </div>
  </div>
</template>

<script>
import HeaderQuery from "@/components/pc/header-query.vue";
import RouteTarget from "@/components/pc/route-target.vue";
import http from "../../axios/index";
import * as cookieServ from "@/utils/methods/cookie";
import * as currHost from "@/utils/methods/domain";
import { getUserInfo } from "../../api/information";
import { mapInfo } from "../../api/president/overview";
export default {
  name: "app",
  components: {
    HeaderQuery,
    RouteTarget
  },
  provide() {
    return {
      app: this
    };
  },
  data() {
    return {
      screenfull: null,
      title: "", // 头部导航名称
      date: "", // 可视化页面的日期
      dateType: "", // 日期类型
      showHeaderQuery: true, // 是否展示头部查询条件
      userName: "",
      userCode: "",
      webtitle: "",
      logo: "",
      platformList: [],
      menuFlag: {
        presidentYmFlag: false,
        presidentYcFlag: false,
        middleDayYmFlag: false,
        middleDayYcFlag: false,
        middleMonthYmFlag: false,
        middleMonthYcFlag: false,
        middleDay: false,
        middleMonth: false
      }, // 菜单列表
      isShow: false,
      presidentYear: "",
      middleYear: "",
      routeName: '',
    };
  },
  methods: {
    toggleFullScreen() {
      this.screenfull && this.screenfull.toggle();
      this.screenfull.isFullscreen && location.reload();
    },
    changedDate(value) {
      this.isRouterActive = false;
      let reg = new RegExp(/^\d{4}$|^\d{4}-((0([1-9]))|(1(0|1|2)))$/);
      let reg2 = new RegExp(/^\d{4}\-\d{2}\-\d{2}$/);
      if (reg.test(value)) {
        this.dateType = value.length > 4 ? "month" : "year";
        this.date = value;
      } else if (reg2.test(value)) {
        this.dateType = "day";
        this.date = value;
      } else {
        this.$message.warning("请选择日期！");
      }
    },
    // 退出
    logout() {
      this.$confirm("执行退出？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        http.post("/user/logout", {}).then(data => {
          if (data.code == "0000") {
            this.$store.dispatch("app/setToken", "");
            // -------------------跳转uyu平台登录（外网测试：分支（ufish-pre、ufish-prod））----------------------
            localStorage.removeItem("orgId");
            localStorage.removeItem("orgName");
            localStorage.removeItem("rootId");
            localStorage.removeItem("rootOrgName");
            cookieServ.clearCookie();
            const uyuHost = currHost.getHost();
            window.location.replace(uyuHost);
            // -------------------------开发测试：分支（ufish-dev、ufish-test）----------------------------------
            // localStorage.removeItem("orgId");
            // localStorage.removeItem("orgName");
            // localStorage.removeItem("rootId");
            // localStorage.removeItem("rootOrgName");
            // cookieServ.clearCookie();
            // this.$router.push("/login");
            // --------------------------------------- END ----------------------------------------------------
          }
        });
      });
    },
    towardPlatform(label) {
      const index = Number(label);
      if (index == 0) {
        const url = cookieServ.getCookie("uyuposition");
        const uyuHost = decodeURIComponent(url);
        // 跳转uyu平台登录
        window.location.replace(uyuHost);
      }
    },
    // 监听浏览器标签页状态为当前项目标签页
    hanldeVisiblityChange() {
      // 监听页面是否是激活状态
      var hiddenProperty =
        "hidden" in document
          ? "hidden"
          : "webkitHidden" in document
            ? "webkitHidden"
            : "mozHidden" in document
              ? "mozHidden"
              : null;
      var visibilityChangeEvent = hiddenProperty.replace(
        /hidden/i,
        "visibilitychange"
      );
      var onVisibilityChange = function () {
        if (!document[hiddenProperty]) {
          // 检查token
          // 项目初始化获取cookie token
          const token = cookieServ.getCookie("token");
          // 跳转uyu平台登录
          if (!token) {
            const uyuHost = currHost.getHost();
            window.location.replace(uyuHost);
            return;
          }
        } else {
          // 页面非激活
        }
      };
      document.addEventListener(visibilityChangeEvent, onVisibilityChange);
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-07-11 11:29:47
     * @description: 获取模块主菜单
     */
    getSidebar() {
      http.get("/menu/getNavByUser").then(data => {
        if (data.code == "0000") {
          const desktopMenu = JSON.stringify(
            data.data.filter(item => item.component === "desktop")[0]
          );
          if (desktopMenu.indexOf("/uyu-desktop/ym") > -1) {
            this.menuFlag.presidentYmFlag = true;
          }
          if (desktopMenu.indexOf("/uyu-desktop/yc") > -1) {
            this.menuFlag.presidentYcFlag = true;
          }
          if (desktopMenu.indexOf("/uyu-desktop/day/ym") > -1) {
            this.menuFlag.middleDayYmFlag = true;
          }
          if (desktopMenu.indexOf("/uyu-desktop/day/yc") > -1) {
            this.menuFlag.middleDayYcFlag = true;
          }
          if (desktopMenu.indexOf("/uyu-desktop/month/ym") > -1) {
            this.menuFlag.middleMonthYmFlag = true;
          }
          if (desktopMenu.indexOf("/uyu-desktop/month/yc") > -1) {
            this.menuFlag.middleMonthYcFlag = true;
          }
          if (desktopMenu.indexOf("/uyu-desktop/day") > -1) {
            this.menuFlag.middleDay = true;
          }
          if (desktopMenu.indexOf("/uyu-desktop/month") > -1) {
            this.menuFlag.middleMonth = true;
          }
          this.$store.dispatch("app/setMenuFlag", this.menuFlag);
        }
      });
    }
  },
  mounted() {
    // 监听浏览器标签页状态为当前项目标签页
    this.hanldeVisiblityChange();
    document.title && (this.title = document.title);
    let _this = this;
    //根据自己需要来监听对应的key
    window.addEventListener("setItemEvent", function (e) {
      //e.key : 是值发生变化的key
      //例如 e.key==="token";
      //e.newValue : 是可以对应的新值
      if (e.key === "year") {
        _this.presidentYear = e.newValue;
        _this.routeName = _this.$route.name;
      }
      if (e.key === "m-year") {
        _this.middleYear = e.newValue;
        _this.routeName = _this.$route.name;
      }
    })
  },
  async created() {
    this.getSidebar();
    this.title = "水产养殖事业部管理桌面";
    // 项目初始化获取cookie token
    const token = cookieServ.getCookie("token");
    // -------------------跳转uyu平台登录（外网测试：分支（ufish-pre、ufish-prod））----------------------
    if (!token) {
      const uyuHost = currHost.getHost();
      window.location.replace(uyuHost);
      return;
    }
    // -------------------------开发测试：分支（ufish-dev、ufish-test）--------------------------------
    // if (!token) {
    //   this.$router.push("/login");
    //   return;
    // }
    // --------------------------------------- END ----------------------------------------------------
    // 存入缓存
    this.$store.dispatch("app/setToken", token);
    const data = cookieServ.getCookie("userInfo");
    const label = cookieServ.getCookie("label");
    this.$store.dispatch("app/setHostLabel", label);
    const returnpath = cookieServ.getCookie("returnpath");
    // decodeURI解码
    this.$store.dispatch("app/setReturnPath", decodeURIComponent(returnpath));
    this.webtitle = "智慧渔业管理平台";

    // 获取用户信息
    const info = await new Promise(resolve => {
      getUserInfo().then(data => {
        resolve(data);
      });
    });
    if (info.code === "0000") {
      this.userName = info.data.userName;
      this.userCode = info.data.userCode;
    }

    // 获取顶级机构Id全局存储
    const orgInfo = await new Promise(resolve => {
      http.get("/desktopReport/queryTopInstitution").then(res => {
        resolve(res);
      });
    });
    if (orgInfo.code == "0000") {
      if (this.$route.path == "/day/yc" && !this.$route.query.flag) {
        localStorage.removeItem("orgId");
        localStorage.removeItem("orgName");
        localStorage.setItem("orgId", orgInfo.data.orgId);
        localStorage.setItem("orgName", orgInfo.data.orgName);
        this.title = orgInfo.data.orgName;
      }
      if (localStorage.getItem("orgId") === null) {
        localStorage.setItem("rootId", orgInfo.data.rootId);
        localStorage.setItem("rootOrgName", orgInfo.data.rootOrgName);
        localStorage.setItem("orgId", orgInfo.data.orgId);
        localStorage.setItem("orgName", orgInfo.data.orgName);
        this.$store.dispatch(
          "app/setRootOrganAddress",
          orgInfo.data.rootOrgAddr
        );
        this.title = orgInfo.data.rootOrgName;
      }
      this.isShow = true;

      // PC-事业部桌面根据根机构获取考核期
      http.post("/desktopReport/queryAssessmentDate", {
        rootId: orgInfo.data.rootId,
        orgId: "",
        baseId: "",
      }).then(data => {
        if (data.code == "0000") {
          localStorage.setItem("year", data.data.year)
        }
      });

      // PC总经理桌面根据当前机构获取考核期
      http.post("/desktopReport/queryAssessmentDate", {
        rootId: "",
        orgId: !this.$route.query.flag ? orgInfo.data.orgId : localStorage.getItem("orgId"),
        baseId: "",
      }).then(data => {
        if (data.code == "0000") {
          localStorage.setItem("m-year", data.data.year)
          localStorage.setItem("m-startDate", data.data.startDate);
        }
      });
    }
    // 总裁桌面用户登录，获取分公司机构信息
    if (orgInfo.data.rootId == orgInfo.data.orgId) {
      const organList = await new Promise(resolve => {
        mapInfo(orgInfo.data.rootId).then(data => {
          if (data.code == "0000") {
            resolve(data.data);
          }
        });
      });

      // 加到store
      organList &&
        organList.length > 0 &&
        this.$store.dispatch("app/setOrganList", organList);
    }
  },
  computed: {
    oldRouter() {
      let oldRouterStr = localStorage.getItem("oldRouter");
      return oldRouterStr;
    }
  },
  watch: {
    $route() {
      const name = this.$route.name;
      // 报表页面标题
      if (name.indexOf("ym-") > -1 || name.indexOf("yc-") > -1) {
        if (name.slice(0, 3) == "yc-" || name.slice(0, 3) == "ym-") {
          this.title = localStorage.getItem("rootOrgName");
        } else if (name.indexOf("-yc-") > -1 || name.indexOf("-ym-") > -1) {
          this.title = localStorage.getItem("orgName");
        }
        document.title = this.$route.meta.title;
        this.showHeaderQuery = false;
      } else {
        // 可视化页面标题
        if (name.indexOf("day-") > -1) {
          this.title = localStorage.getItem("orgName");
        } else if (name.indexOf("month-") > -1) {
          this.title = localStorage.getItem("orgName");
        } else if (name == "yc" || name == "ym") {
          this.title = localStorage.getItem("rootOrgName");
        } else {
          document.title = "水产养殖事业部管理桌面";
        }
        document.title = this.$route.meta.title;
        this.showHeaderQuery = true;
      }
    }
  }
};
</script>

<style lang="less">
// 初始样式
@import "./init.less";
</style>
<style lang="less" scoped>
// 当前页面样式
@import "./app.less";

.container-title {
  position: relative;
}

.uyu-setting-box {
  position: absolute;
  right: 30px;
  top: 0;
  bottom: 0;
  width: auto;

  // 退出按钮
  .exit {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    background-color: transparent;
    border: none;
    outline: none;
    cursor: pointer;

    &:hover {
      color: #5442ff;
    }
  }

  .view-change {
    display: inline-block;
    margin-right: 40px;

    .view-change-title {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      display: inline-block;
      position: relative;

      &:hover {
        color: #5442ff;
      }

      &::after {
        content: "";
        display: inline-block;
        width: 1px;
        height: 13px;
        background-color: #615d5d;
        position: absolute;
        top: 34px;
        right: -20px;
      }
    }
  }

  /*****************************右上角弹出框 ********************************/
  .language-body {
    display: inline-block;
    height: 50px;
    width: auto;
    line-height: 50px;
    position: relative;
  }

  .language-body:hover {
    background-color: transparent;
  }

  .language-body .el-icon-arrow-up {
    display: none;
    font-size: 12px;
  }

  .language-body .el-icon-arrow-down {
    display: inline-block;
    font-size: 12px;
  }

  .language-body:hover .el-icon-arrow-up {
    display: inline-block;
  }

  .language-body:hover .el-icon-arrow-down {
    display: none;
  }

  .language-body .body-button {
    width: 100%;
    visibility: hidden;
    position: absolute;
    top: 50px;
    background-color: #232739;
    transition: all 0.2s ease-in-out;
  }

  .language-body:hover .body-button {
    visibility: visible;
  }

  body-button-inner {
    width: 100%;
    height: 50px;
  }

  .body-button-inner button {
    outline: none;
    border: none;
    border-radius: unset;
    background-color: transparent;
    color: #fff;
    font-size: 14px;
    width: 100%;
    text-align: left;
    padding-left: 10px;
    font-family: "Arial", "MicrosoftYaHei";
    font-weight: 400;
  }

  .body-button-inner button:hover {
    color: #5574fa;
  }

  .body-text {
    font-family: "Arial", "MicrosoftYaHei";
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
  }

  .body-text .topbar-title {
    display: inline-block;
    margin-left: 10px;
    font-size: 14px;
  }

  .body-text .topbar-icon {
    display: inline-block;
  }

  .body-text .topbar-icon>span {
    border: none !important;
    padding: 0 12px 0 6px;
  }

  .uppop-toward {
    width: 335px !important;
    /* height: 391px; */
    background-color: #ffffff !important;
    -webkit-box-shadow: 0px 3px 13px 0px rgb(200 203 214 / 45%);
    box-shadow: 0px 3px 13px 0px rgb(200 203 214 / 45%);
    top: 48px !important;
    right: 10px;
    z-index: 999;
  }

  .uppop-toward .title {
    font-size: 17px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #232634;
    height: 60px;
    width: calc(100% - 52px);
    margin-left: 26px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 334%;
    text-align: left;
  }

  .uppop-toward hr {
    width: calc(100% - 52px);
    height: 1px;
    border: none;
    border-top: 1px solid #e2e5f3;
    -webkit-box-sizing: border-box;
    margin-left: 26px;
    margin-top: 0;
    margin-bottom: 0;
  }

  .uppop-toward .menu:hover {
    background: #f1f2f7;
  }

  .uppop-toward .body-button-inner button {
    font-size: 17px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #7e849e;
    height: 60px;
    padding-left: 30px;
    display: flex;
    align-items: center;
    position: relative;
  }

  .uppop-toward .body-button-inner button i {
    position: absolute;
    right: 25px;
    top: 24px;
  }

  .uppop-toward .body-button-inner button.exit {
    height: 57px !important;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #232634 !important;
  }

  .uppop-toward button.exit:hover {
    color: #5574fa !important;
  }
}
</style>